import { Dropdown, Tab, Tabs } from "react-bootstrap";
import NotFoundComponent from "../../../NotFound/NotFoundComponent";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState, useCallback, useRef } from "react";
import _ from "lodash";
import {
  getCoachingListing,
  getCoachingListingClear,
  getCoachingPersonalListing,
  getCoachingPersonalListingClear,
  GetCoachingServices,
  GetCoachingServicesResClear,
  GetMasterIndustryData,
  GetMasterIndustryDataResClear,
} from "../../../../../redux/coaching/actions";
import CONFIG from "../../../../../utils/config";
import API_LIST from "../../../../../utils/apiList";
import {
  getProcureInfo,
  ProductCardPriceInfo,
  SessionKeys,
} from "../../../../../utils/AppUtils";
import SlotBookingModal from "../SlotBookingModal";
import Rating from "@mui/material/Rating";
import Slider, { Range } from "rc-slider";
import "rc-slider/assets/index.css";
import ProductCardComponent from "../../../ProductCard/ProductCardComponent";
import ShimmerScreen from "../../../../Layouts/ShimmerScreen";
import NotFoundImage from "../../../NotFound/NotFoundImage";
import "./MyCoachingServicesListing.scss";

const MyCoachingServicesListing = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const observer = useRef();

  const [isLoading, setIsLoading] = useState(true);

  const coachingPersonalListingRes = useSelector(
    (state) => state.coaching.coachingServicesData
  );
  const [key, setKey] = useState("YourCoaches");
  const [coachList, setCoachList] = useState(CONFIG.INITIAL_PRODUCT_CARD_DATA);
  const [filtersData, setFiltersData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [sessionModal, setSessionModal] = useState(false);
  const [selectedCoachId, setSelectedCoachId] = useState("");
  const [productTitle, setProductTitle] = useState("");
  const [productId, setProductId] = useState("");
  const [displayName, setDisplayName] = useState("");

  const [isFetching, setIsFetching] = useState(false);
  const [hasNoMore, setHasNoMore] = useState(true);
  const [totalRecords, setTotalRecords] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [pageNum, setPageNum] = useState(1);

  //language filter related states
  const [languageSearch, setLanguageSearch] = useState("");
  const [selectedLanguageItems, setSelectedLanguageItems] = useState([]);
  const [showLanguageDropdown, setShowLanguageDropdown] = useState(false);
  const [filteredLanguages, setFilteredLanguages] = useState([]);
  const [originalLanguages, setOriginalLanguages] = useState([]);

  //skills  filter states
  const [skillSearch, setSkillSearch] = useState("");
  const [selectedSkillItems, setSelectedSkillItems] = useState([]);
  const [showSkillDropdown, setShowSkillDropdown] = useState(false);
  const [filteredSkills, setFilteredSkills] = useState([]);
  const [originalSkills, setOriginalSkills] = useState([]);

  //rating filter states
  const [range, setRange] = useState([0, 5]); // Initial range values
  const [showRatingDropdown, setShowRatingDropdown] = useState(false);
  const [industriesData, setIndustriesData] = useState([]);

  const search = window.location.search;
  const params = new URLSearchParams(search);

  const myCoaches = params.get("mycoaches");
  let industries = params.get("industries");
  let languages = params.get("languages");
  let countries = params.get("countries");
  let skills = params.get("skills");
  let rating = params.get("rating");

  const industryListingRes = useSelector(
    (state) => state.coaching.getMasterIndustryData
  );

  const [selectedIndustries, setSelectedIndustries] = useState(
    industries ? [industries] : []
  );

  const [apiCalled, setApiCalled] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    console.log("myCoaches", myCoaches);
    fetchPersonalCoachListing("", false);
  }, [
    dispatch,
    industries,
    languages,
    countries,
    skills,
    rating,
    window.location.pathname,
  ]);

  useEffect(() => {
    console.log("myCoaches", selectedIndustries);
    fetchPersonalCoachListing("", false);
  }, [selectedIndustries]);

  const [industryLoading, setIndustryLoading] = useState(false);
  useEffect(() => {
    getIndustriesAPI();
    return () => {
      dispatch(GetMasterIndustryDataResClear());
    };
  }, []);

  const getIndustriesAPI = () => {
    setIndustryLoading(true);
    dispatch(
      GetMasterIndustryData({
        module: "masterIndustryData",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          type: "coaching_service",
        },
      })
    );
  };

  useEffect(() => {
    console.log("indus--", industryListingRes);
    if (!_.isEmpty(industryListingRes)) {
      if (industryListingRes?.status === "success") {
        let data = industryListingRes?.payload?.payload;
        setIndustriesData(data);
        setIndustryLoading(false);
      } else {
        setIndustriesData([]);
        setIndustryLoading(false);
      }
    }
  }, [industryListingRes]);
  useEffect(() => {
    fetchPersonalCoachListing();
  }, [pageNum]);

  const formatCoachCardData = (arrList) => {
    if (!_.isEmpty(arrList)) {
      let prodArr = [];
      for (let coach of arrList) {
        console.log("coach---", coach);
        let btnTitle = "";
        let priceInfo = getProcureInfo(coach?.purchased_info);
        coach.priceInfo = priceInfo;
        if (coach?.priceInfo?.isPurchased) {
          btnTitle = t("RequestForASession");
        } else {
          btnTitle = t("Explore");
        }

        prodArr.push({
          id: coach?.id,
          ecom_id: coach?.ecom_id ? coach?.ecom_id : coach?.wc_post_id,
          is_like: false,
          is_bookmark: false,
          is_wishlist: false,
          dbId: coach?.list_id,
          productType: "coach",
          productOrigin: coach?.origin,
          title: coach?.display_name,
          logoURL: coach?.provider?.provider_img
            ? coach?.provider?.provider_img
            : "",
          bannerURL: coach?.profile_image
            ? coach?.profile_image
            : "https://cdnstg.training.com/halifax/image/10543/2058509172-20241212.png",
          tagsArray: [],
          description: coach?.short_description,
          btnTitle: btnTitle,
          progress: coach?.crs_progress,
          showRating: true,
          ratings: coach?.ratings,
          skills: [], //coach?.user_skill,
          showIndustry: false,
          industry: !_.isEmpty(coach?.user_industry)
            ? coach?.user_industry[0]
            : "",
          showExperience: false,
          experience: coach?.experience,
          btnAction: () => {
            if (coach?.priceInfo?.isPurchased) {
              setSelectedCoachId(coach?.user_id);
              setProductTitle(coach?.product_title);
              setProductId(coach?.product_id);
              setDisplayName(coach?.display_name);

              setSessionModal(true);
            } else {
              handleCoachDetailNavigate(coach?.product_sku);
            }
          },
          descAction: {},
          bannerAction: () => {
            if (coach?.priceInfo?.isPurchased) {
              setSelectedCoachId(coach?.user_id);
              setProductTitle(coach?.product_title);
              setProductId(coach?.product_id);
              setDisplayName(coach?.display_name);

              setSessionModal(true);
            } else {
              handleCoachDetailNavigate(coach?.product_sku);
            }
          },
          footerLineComp: !_.isEmpty(priceInfo)
            ? ProductCardPriceInfo(priceInfo.showText, priceInfo.textColor)
            : "",
          showHeader: true,
          showProviderIcon: false,
          showLikeMenu: false,
          showBody: true,
          showFooter: true,
          showProgress: false,
          cardClassName: "",
          rightBtnIcon: "/images/arrow-right.svg",
          leftBtnIcon: "",

          priceInfo,
          isBundle: false,
        });
      }
      return prodArr;
    }
  };

  useEffect(() => {
    if (!_.isEmpty(coachingPersonalListingRes)) {
      if (coachingPersonalListingRes?.status === "success" && apiCalled) {
        console.log("coachingListingRes", coachingPersonalListingRes);
        const listData =
          coachingPersonalListingRes?.payload?.payload?.listing?.coaching;
        for (let coach of listData) {
          coach.priceInfo = getProcureInfo(coach.purchased_info);
        }

        let formattedCoachData = formatCoachCardData(listData);
        let newProdArr = formattedCoachData;
        if (pageNum > 1) {
          newProdArr = [...coachList, ...formatCoachCardData];
          console.log(newProdArr);
          setCoachList(newProdArr);
          setIsFetching(false);
        } else {
          setCoachList(formattedCoachData);
        }

        console.log(
          "recordsLength: ",
          coachingPersonalListingRes?.payload?.payload?.listing?.total_records
        );
        if (
          coachingPersonalListingRes?.payload?.payload?.listing
            ?.total_records === newProdArr?.length
        ) {
          setIsFetching(false);
          setHasNoMore(true);
        } else {
          setHasNoMore(false);
        }
        const filterData =
          coachingPersonalListingRes?.payload?.payload?.filters;
        setFiltersData(filterData);

        let languagesFilters = filterData?.languages;
        setOriginalLanguages(languagesFilters);
        setFilteredLanguages(languagesFilters);

        let skillsFilters = filterData?.skills;
        setOriginalSkills(skillsFilters);
        setFilteredSkills(skillsFilters);
      }
      setIsLoading(false);
      dispatch(GetCoachingServicesResClear());
    }
  }, [coachingPersonalListingRes]);

  const fetchPersonalCoachListing = (searchText, isEmptyRating) => {
    setApiCalled(true);
    setCoachList(CONFIG.INITIAL_PRODUCT_CARD_DATA);
    if (isEmptyRating) {
      setRange([0, 5]);
    }
    setIsLoading(true);
    const decodedRange = decodeURIComponent(rating);
    console.log("range---", decodedRange, range);
    // const [min, max] = decodedRange.split("-").map(Number);
    let min = 0;
    let max = 5;
    if (decodedRange != null) {
      const rangeValues = decodedRange.split("-");

      if (rangeValues.length === 2) {
        min = isNaN(Number(rangeValues[0])) ? 0 : Number(rangeValues[0]);
        max = isNaN(Number(rangeValues[1])) ? 5 : Number(rangeValues[1]);
        setRange([min, max]);
      }
    }
    console.log("range---2", decodedRange, range);
    if (!_.isEmpty(skills)) {
      setSelectedSkillItems(decodeURIComponent(skills).split(","));
    }
    if (!_.isEmpty(languages)) {
      setSelectedLanguageItems(decodeURIComponent(languages).split(","));
    }

    dispatch(
      GetCoachingServices({
        module: "getCoachingServices",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          type: "coaching_service",
          sort_by: "ASC",
          page: pageNum,
          page_size: pageSize,
          industry: _.isEmpty(industries)
            ? []
            : decodeURIComponent(industries).split(","),
          language: !_.isEmpty(languages)
            ? decodeURIComponent(languages).split(",")
            : [],
          skill: !_.isEmpty(skills)
            ? decodeURIComponent(skills).split(",")
            : [],
          rating: isEmptyRating
            ? "0-5"
            : min || max
            ? `${min}-${max}`
            : `${range[0]}-${range[1]}`,

          search: searchText,
        },
      })
    );
  };

  const paginateCB = useCallback(
    (node) => {
      if (isFetching) return;

      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {
        console.log("pageNumhasNoMore ", isFetching, entries[0].isIntersecting);
        if (entries[0].isIntersecting && !hasNoMore) {
          setIsFetching(true);
          setHasNoMore(true);
          // console.log('End of file', totalRecords, lpListing.length, pageNum, isLoading, isFetching)
          setPageNum((pageNum) => pageNum + 1); //pageNum => pageNum + 1
          setCoachList([...coachList, ...CONFIG.INITIAL_PRODUCT_CARD_DATA]);
        }
      });

      if (node) observer.current.observe(node);
      console.log(node);
    },
    [hasNoMore]
  );

  const toggleLanguageDropdown = () => {
    setShowSkillDropdown(false);
    setShowRatingDropdown(false);
    setShowLanguageDropdown((prev) => !prev);
  };

  const handleLanguageSearchChange = (e) => setLanguageSearch(e.target.value);

  useEffect(() => {
    setFilteredLanguages(
      originalLanguages?.filter((item) =>
        item?.display_name
          ?.toLowerCase()
          ?.includes(languageSearch?.toLowerCase())
      )
    );
  }, [languageSearch]);

  const handleLanguageCheckboxChange = (item) => {
    setSelectedLanguageItems((prev) =>
      prev.includes(item) ? prev.filter((i) => i !== item) : [...prev, item]
    );
  };

  const handleLanguageApply = () => {
    if (selectedLanguageItems.length > 0) {
      const params = new URLSearchParams(window.location.search);
      params.set(
        "languages",
        encodeURIComponent(selectedLanguageItems.join(","))
      );
      window.history.replaceState(
        {},
        "",
        `${window.location.pathname}?${params.toString()}`
      );
    } else {
      alert("No filters selected! Please select at least one.");
    }
    setLanguageSearch("");
    setShowLanguageDropdown(false);
  };

  const toggleSkillDropdown = () => {
    setShowLanguageDropdown(false);

    setShowRatingDropdown(false);
    setShowSkillDropdown((prev) => !prev);
  };

  const handleSkillSearchChange = (e) => setSkillSearch(e.target.value);

  useEffect(() => {
    setFilteredSkills(
      originalSkills?.filter((item) =>
        item?.name?.toLowerCase()?.includes(skillSearch?.toLowerCase())
      )
    );
  }, [skillSearch]);

  const handleSkillCheckboxChange = (item) => {
    setSelectedSkillItems((prev) =>
      prev.includes(item) ? prev.filter((i) => i !== item) : [...prev, item]
    );
  };

  const handleSkillApply = () => {
    if (selectedSkillItems.length > 0) {
      const params = new URLSearchParams(window.location.search);
      params.set("skills", encodeURIComponent(selectedSkillItems.join(",")));
      window.history.replaceState(
        {},
        "",
        `${window.location.pathname}?${params.toString()}`
      );
    } else {
      alert("No filters selected! Please select at least one.");
    }
    setSkillSearch("");
    setShowSkillDropdown(false);
  };

  const toggleRatingDropdown = () => {
    setShowLanguageDropdown(false);
    setShowSkillDropdown(false);

    setShowRatingDropdown((prev) => !prev);
  };

  const handleRangeChange = (value) => {
    console.log("range---value", value);
    setRange(value); // Update the range state dynamically
  };

  const handleRatingApply = () => {
    if (!_.isEmpty(range)) {
      const params = new URLSearchParams(window.location.search);
      params.set("rating", encodeURIComponent(`${range[0]}-${range[1]}`));
      window.history.replaceState(
        {},
        "",
        `${window.location.pathname}?${params.toString()}`
      );
    } else {
      alert("No filters selected! Please select at least one.");
    }
    setRange([0, 5]);
    setShowRatingDropdown(false);
  };

  const handleCoachDetailNavigate = (coach_id) => {
    let paramsReq = {
      service_code: coach_id,
    };
    let jsonString = JSON.stringify(paramsReq);
    let encodedUrl = btoa(jsonString);
    navigate(`/coach-service/detail?c=${encodedUrl}`);
  };

  const handleResetAllFilters = () => {
    const url = new URL(window.location.href);
    const industryParam = url.searchParams.get("industries");
    url.search = "";
    if (industryParam) {
      url.searchParams.set("industry", industryParam);
    }
    window.history.pushState({}, "", url.href);

    rating = [];
    skills = [];

    languages = [];

    setSelectedLanguageItems([]);
    setSelectedSkillItems([]);

    setShowLanguageDropdown(false);
    setShowRatingDropdown(false);
    setShowSkillDropdown(false);
    setCoachList(CONFIG.INITIAL_PRODUCT_CARD_DATA);
    fetchPersonalCoachListing("", true);
  };

  useEffect(() => {
    console.log("range----useeffect", range, range[0], range[1]);
  }, [range]);

  const handleSelectedIndustries = (id) => {
    let ids = [];
    ids.push(id);
    let updatedIds = [];
    if (selectedIndustries?.includes(id)) {
      updatedIds = selectedIndustries.filter((item) => item !== id);
    } else {
      updatedIds = [...selectedIndustries, ...ids];
    }

    const params = new URLSearchParams(window.location.search);
    params.set("industries", encodeURIComponent(updatedIds.join(",")));
    window.history.replaceState(
      {},
      "",
      `${window.location.pathname}?${params.toString()}`
    );
    setSelectedIndustries(updatedIds);
  };


  useEffect(() => {
    if (searchText?.length > 2) {
      fetchPersonalCoachListing(searchText);
    } else if (searchText?.length === 0) {
      fetchPersonalCoachListing("");
    }
  }, [searchText]);

  return (
    <>
      <div className="container suggested-coaching">
        <div className="row">
          <div className="col-12">
            <h3 className="mentor-title mb-0">{t("Coaching Services")}</h3>
          </div>
        </div>
        <div className="row mt-4">
          <div className="d-flex gap-4 flex-wrap">
            {industryLoading ? (
              [1, 2, 3, 4, 5, 6, 7, 8]?.map((item) => (
                <>
                  <div className="col-3 mt-3">
                    <div className=" text-center align-items-center">
                      <div>
                        <ShimmerScreen case="rect" height="8rem" width="100%" />
                      </div>
                      <div>
                        <ShimmerScreen
                          case="rect"
                          height="1.5rem"
                          width="100%"
                        />
                      </div>
                    </div>
                  </div>
                </>
              ))
            ) : !_.isEmpty(industriesData) ? (
              industriesData?.map((item, i) => {
                return (
                  <div
                    className={`coach-box text-center align-items-center cursor-pointer ${
                      selectedIndustries?.includes(item?.id) ? "selected" : ""
                    }`}
                    onClick={() => handleSelectedIndustries(item?.id)}
                  >
                    <div className="mdbxd">
                      <img src={item?.image} alt={item?.name} />
                    </div>
                    <div className="edsfebox">
                      <strong> {item?.name}</strong>
                    </div>
                  </div>
                );
              })
            ) : (
              <div className="not-found cart-notfound">
                <div className="interboxes">
                  <NotFoundImage width={200} height={200} />
                  <p>No Industries Found.</p>
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="row mt-4">
          <div className="col-12">
            <div className="contsection">
              <div className="inner-content-caoch pt-4">
                <div className="s-earch-and-filters d-flex gap-3 justify-content-between mb-3 flex-wrap">
                  <div className="search-filter position-relative">
                    <input
                      type="search"
                      placeholder={t("Search")}
                      id="inputPassword2"
                      className="form-control"
                      value={searchText}
                      onChange={(e) => {
                        setSearchText(e.target.value);
                      }}
                      disabled={isLoading}
                    />
                  </div>

                  <div className="filter-section">
                    <div className="filter-option-listing d-flex justify-content-start gap-2 flex-wrap">
                      <div className="filter-btn">
                        <div className="position-relative">
                          <button
                            className="btn btn-outline-primary w-100 dropdown-toggle"
                            onClick={toggleLanguageDropdown}
                            disabled={isLoading}
                          >
                            {t("language")}
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="10"
                              viewBox="0 0 20 10"
                              fill="none"
                            >
                              <path
                                d="M18.9587 1.78879L10.7517 9.65205C10.4939 9.86695 10.236 9.95285 10.0212 9.95285C9.7634 9.95285 9.50559 9.86695 9.29074 9.69505L1.04074 1.78879C0.611052 1.40207 0.611052 0.714569 0.99777 0.327849C1.38449 -0.101839 2.07199 -0.101839 2.45871 0.284879L10.0212 7.50363L17.5407 0.284879C17.9274 -0.101839 18.615 -0.101839 19.0017 0.327849C19.3884 0.714569 19.3884 1.40207 18.9587 1.78879Z"
                                fill="#2D2D2D"
                              />
                            </svg>
                          </button>

                          {showLanguageDropdown && (
                            <div
                               className="border rounded bg-white p-3 filter-drop"
                              style={{
                                position: "absolute",
                                top: "100%",
                                left: 0,
                                zIndex: 1050,
                                width: "200px",
                                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                              }}
                            >
                              <input
                                type="text"
                                className="form-control mb-2"
                                placeholder="Search..."
                                value={languageSearch}
                                onChange={handleLanguageSearchChange}
                              />

                              <div
                                style={{
                                  maxHeight: "100px",
                                  overflowY: "auto",
                                }}
                              >
                                {filteredLanguages?.length > 0 ? (
                                  filteredLanguages?.map((item) => (
                                    <div key={item?.id} className="form-check">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value={item}
                                        id={`checkbox-${item}`}
                                        checked={selectedLanguageItems.includes(
                                          item?.display_name
                                        )}
                                        onChange={() =>
                                          handleLanguageCheckboxChange(
                                            item?.display_name
                                          )
                                        }
                                      />
                                      <label
                                        className="form-check-label"
                                        htmlFor={`checkbox-${item?.id}`}
                                      >
                                        {item?.display_name}
                                      </label>
                                    </div>
                                  ))
                                ) : (
                                  <p className="text-muted">
                                    {t("No items found")}
                                  </p>
                                )}
                              </div>

                              <button
                                className="btn btn-primary w-100 mt-2"
                                onClick={handleLanguageApply}
                                disabled={_.isEmpty(selectedLanguageItems)}
                              >
                                {t("Apply")}
                              </button>
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="filter-btn">
                        <div className="position-relative">
                          <button
                            className="btn btn-outline-primary w-100 dropdown-toggle"
                            onClick={toggleRatingDropdown}
                            disabled={isLoading}
                          >
                            {t("Rating")}
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="10"
                              viewBox="0 0 20 10"
                              fill="none"
                            >
                              <path
                                d="M18.9587 1.78879L10.7517 9.65205C10.4939 9.86695 10.236 9.95285 10.0212 9.95285C9.7634 9.95285 9.50559 9.86695 9.29074 9.69505L1.04074 1.78879C0.611052 1.40207 0.611052 0.714569 0.99777 0.327849C1.38449 -0.101839 2.07199 -0.101839 2.45871 0.284879L10.0212 7.50363L17.5407 0.284879C17.9274 -0.101839 18.615 -0.101839 19.0017 0.327849C19.3884 0.714569 19.3884 1.40207 18.9587 1.78879Z"
                                fill="#2D2D2D"
                              />
                            </svg>
                          </button>

                          {showRatingDropdown && (
                            <>
                              <div
                                className="border rounded bg-white p-3 filter-drop"
                                // style={{
                                //   position: "absolute",
                                //   top: "100%",
                                //   left: 0,
                                //   zIndex: 1050,
                                //   width: "200px",
                                //   boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                                // }}
                              >
                                {range ? (
                                  <p>
                                    {t("Currently")}: {range[0]} - {range[1]}
                                  </p>
                                ) : (
                                  ""
                                )}

                                <Slider
                                  range
                                  min={0}
                                  max={5}
                                  step={1}
                                  defaultValue={range}
                                  value={range}
                                  onChange={handleRangeChange}
                                  allowCross={false}
                                  trackStyle={[
                                    {
                                      backgroundColor: "#87CEEB",
                                      height: 6,
                                    },
                                  ]}
                                  handleStyle={[
                                    {
                                      backgroundColor: "#87CEEB",
                                      borderColor: "#87CEEB",
                                    },
                                    {
                                      backgroundColor: "#87CEEB",
                                      borderColor: "#87CEEB",
                                    },
                                  ]}
                                  railStyle={{
                                    backgroundColor: "#ddd",
                                    height: 6,
                                  }}
                                  tipFormatter={(value) => `${value}`}
                                />
                                <button
                                  className="btn btn-primary w-100 mt-2"
                                  onClick={handleRatingApply}
                                >
                                  {t("Apply")}
                                </button>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                      <div className="filter-btn">
                        <div className="position-relative">
                          <button
                            className="btn btn-outline-primary w-100 dropdown-toggle"
                            onClick={toggleSkillDropdown}
                            disabled={isLoading}
                          >
                            {t("skills")}
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="10"
                              viewBox="0 0 20 10"
                              fill="none"
                            >
                              <path
                                d="M18.9587 1.78879L10.7517 9.65205C10.4939 9.86695 10.236 9.95285 10.0212 9.95285C9.7634 9.95285 9.50559 9.86695 9.29074 9.69505L1.04074 1.78879C0.611052 1.40207 0.611052 0.714569 0.99777 0.327849C1.38449 -0.101839 2.07199 -0.101839 2.45871 0.284879L10.0212 7.50363L17.5407 0.284879C17.9274 -0.101839 18.615 -0.101839 19.0017 0.327849C19.3884 0.714569 19.3884 1.40207 18.9587 1.78879Z"
                                fill="#2D2D2D"
                              />
                            </svg>
                          </button>

                          {showSkillDropdown && (
                            <div
                               className="border rounded bg-white p-3 filter-drop"
                              // style={{
                              //   position: "absolute",
                              //   top: "100%",
                              //   left: 0,
                              //   zIndex: 1050,
                              //   width: "200px",
                              //   boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                              // }}
                            >
                              <input
                                type="text"
                                className="form-control mb-2"
                                placeholder="Search..."
                                value={skillSearch}
                                onChange={handleSkillSearchChange}
                              />

                              <div
                                style={{
                                  maxHeight: "100px",
                                  overflowY: "auto",
                                }}
                              >
                                {filteredSkills?.length > 0 ? (
                                  filteredSkills?.map((item) => (
                                    <div key={item} className="form-check">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value={item}
                                        id={`checkbox-${item}`}
                                        checked={selectedSkillItems.includes(
                                          item?.id
                                        )}
                                        onChange={() =>
                                          handleSkillCheckboxChange(item?.id)
                                        }
                                      />
                                      <label
                                        className="form-check-label"
                                        htmlFor={`checkbox-${item}`}
                                      >
                                        {item?.name}
                                      </label>
                                    </div>
                                  ))
                                ) : (
                                  <p className="text-muted">
                                    {t("No items found")}
                                  </p>
                                )}
                              </div>

                              <button
                                className="btn btn-primary w-100 mt-2"
                                onClick={handleSkillApply}
                                disabled={_.isEmpty(selectedSkillItems)}
                              >
                                {t("Apply")}
                              </button>
                            </div>
                          )}
                        </div>
                      </div>

                      {!_.isEmpty(languages) ||
                      !_.isEmpty(rating) ||
                      !_.isEmpty(skills) ? (
                        <div className="filter-btn">
                          <div className="position-relative">
                            <button
                              className="w-100 reset-buttonc"
                              onClick={handleResetAllFilters}
                              disabled={isLoading}
                            >
                              {t("Reset All")}
                            </button>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
                <div className="councoa d-flex justify-content-start mb-3">
                  {isLoading ? (
                    <ShimmerScreen case="rect" width="10rem" height="2.25rem" />
                  ) : (
                    !_.isEmpty(coachList) && (
                      <p>
                        {t("We found")} {coachList?.length}{" "}
                        {t("coaching service")}(s)
                      </p>
                    )
                  )}
                </div>
                <div className="row coach-list g-xxl-5 g-4">
                  {!_.isEmpty(coachList) ? (
                    coachList?.map((item, i) => {
                      console.log("check000", item);
                      return (
                        <ProductCardComponent
                          {...item}
                          key={`course-${i + 1}`}
                          lastKey={coachList?.length === i + 1}
                          refInfo={paginateCB}
                        />
                      );
                    })
                  ) : (
                    <NotFoundComponent
                      width={200}
                      height={219}
                      showBtn={false}
                      showMsg={true}
                      msgLine={t("No Coach Found!")}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {sessionModal && (
        <SlotBookingModal
          sessionModal={sessionModal}
          setSessionModal={setSessionModal}
          selectedCoachId={selectedCoachId}
          setIsLoading={setIsLoading}
          productTitle={productTitle}
          productId={productId}
          displayName={displayName}
        />
      )}
    </>
  );
};

export default MyCoachingServicesListing;
